export class BrowserService {
  redirect(redirectUrl) {
    document.location = redirectUrl;
  }

  async redirectDelayed(redirectUrl) {
    // NOTE: Delay redirect to test the effect of event dispatch within test environments
    if (import.meta.env.MODE === 'test') await new Promise((r) => setTimeout(r, 500));
    document.location = redirectUrl;
  }

  reload() {
    window.location.replace(window.location);
  }
}

export default new BrowserService();
